<template>
  <transition :name="fadeIn">
    <div class="v-dialog" v-if="show">
      <div class="dialog-mask"></div>
      <div class="dialog" v-show="show">
        <div class="dialog-content">
          <div class="dialog-title" v-if="title">{{ title }}</div>
          <div class="text-content" v-html="contentHtml">
            {{ contentHtml }}
          </div>
        </div>
        <div class="dialog-btns jrm-border-1px jrm-border-top " v-if="close">
          <div
            v-for="(item, index) in btns"
            :key="index"
            class="js-btn jrm-border-1px jrm-border-top dialog-btn"
            @click="onBtnClick(index, item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      default: false
    },
    title: {
      default: ""
    },
    contentHtml: {
      default: ""
    },
    close: {
      default: true
    },
    btns: {
      type: Array,
      default: function() {
        return [
          {
            isHide: true,
            name: "我知道了",
            callback: () => {
            }
          }
        ];
      }
    }
  },
  methods: {
    onBtnClick(index, btn = {}) {
      let { isHide, callback } = btn;
      if (isHide === undefined) {
        isHide = true;
      }
      if (isHide) {
        this.show = false;
        callback && callback();
      } else {
        this.show = true;
        callback && callback();
      }
    }
  },
  computed: {
    fadeIn() {
      return "fadeIn";
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/scss/px2rem.scss";

.v-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.6);
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  -webkit-transition-property: background-color;
  transition-property: background-color;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 300ms;
  transition-duration: 300ms;
}

.dialog {
  z-index: 1000;
  width: px2rem(630);
  background-color: #fff;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -webkit-user-drag: none;
  // opacity: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: px2rem(10);
}

.dialog-content {
  padding: px2rem(50) 0;
  color: #333333;
  font-size: px2rem(28);
  letter-spacing: 0;
  line-height: px2rem(48);
  border-bottom: 1px solid #eee;

  .dialog-title {
    color: #333;
    text-align: center;
    
    padding: 0 px2rem(50) px2rem(20);
    font-size: px2rem(34);
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    line-height: px2rem(58);
  }
  .text-content {
    color: #666;
    padding: 0 px2rem(50);
    text-align: center;
    font-size: px2rem(28);
    letter-spacing: 0;
    line-height: px2rem(48);
  }
  .p {
    font-size: px2rem(28);
    color: #333333;
    letter-spacing: 0;
    line-height: px2rem(48);
    text-align: left;
  }
}

.dialog-btns {
  display: flex;
  flex: 0 0 1;
  flex-direction: row;

  .dialog-btn {
    &:first-child {
      border-left: none;
    }
    &:last-child {
      color: #4D7BFE;
    }
    flex: 1;
    height: px2rem(100);
    line-height: px2rem(100);
    text-align: center;
    font-size: px2rem(32);
    color: #666666;
    letter-spacing: 0;
    text-align: center;
    border-left: 1px solid #eee;
  }
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 0.3s;
}
.fadeIn-enter,
.fadeIn-leave-active {
  opacity: 0;
}
</style>
